export interface ValidatedMobileNumber {
  original: string;
  isValid: boolean;
  isValidMobileNumber: boolean;
  formatted: string;
  mobileId: string;
}

export const cleanMobileNumber = async (
  phone: string,
  countryCode?: string,
): Promise<ValidatedMobileNumber> => {
  const GooglePhoneNumberLib = await import("google-libphonenumber");
  const phoneUtil = GooglePhoneNumberLib.PhoneNumberUtil.getInstance();
  try {
    const number = phoneUtil.parse(phone, countryCode);
    const mobileId = phoneUtil.format(
      number,
      GooglePhoneNumberLib.PhoneNumberFormat.E164,
    );

    const isEdgeCase = (() => {
      if (mobileId.length === 11 && mobileId.substring(0, 4) === "9474") {
        return true;
      }
      if (
        mobileId.substring(0, 5) === "92370" ||
        mobileId.substring(0, 6) === "+92370"
      ) {
        return true;
      }
      return false;
    })();

    const isValidNumber = (() => {
      const defaultCheck = phoneUtil.isValidNumber(number);
      return defaultCheck || isEdgeCase;
    })();

    const isValidMobileNumber = (() => {
      const defaultCheck =
        phoneUtil.isValidNumber(number) &&
        (phoneUtil.getNumberType(number) ===
          GooglePhoneNumberLib.PhoneNumberType.MOBILE ||
          phoneUtil.getNumberType(number) ===
            GooglePhoneNumberLib.PhoneNumberType.FIXED_LINE_OR_MOBILE);
      return defaultCheck || isEdgeCase;
    })();
    return {
      original: phone,
      isValid: isValidNumber,
      isValidMobileNumber: isValidMobileNumber,
      formatted: phoneUtil.format(
        number,
        GooglePhoneNumberLib.PhoneNumberFormat.INTERNATIONAL,
      ),
      mobileId: mobileId,
    };
  } catch (e) {
    return {
      original: phone,
      isValid: false,
      isValidMobileNumber: false,
      formatted: phone,
      mobileId: getMobileId(phone),
    };
  }
};

export const getMobileId = (mobile: string = "", countryCode?: string) => {
  // Remove all non-numerical characters using regular expression
  // Returns in PhoneNumberFormat.E16 eg: +1234567890
  if (!mobile) {
    return "";
  }
  const cleanInput = mobile.replace(/[^0-9]/g, "");
  // Ensure the cleanInput starts with '+'
  if (!cleanInput.startsWith("+")) {
    if (countryCode) {
      return `${countryCode}${cleanInput}`;
    }
    return `+${cleanInput}`;
  }
  return cleanInput;
};
